import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { BenefitsSection } from '../components/sales/BenefitsSection';
import { PriceSection } from '../components/sales/PriceSection';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-yellow-500 selection:text-slate-900" data-id="element-159">
      <HeroSection data-id="element-160" />
      <ProblemSection data-id="element-161" />
      <SolutionSection data-id="element-162" />
      <BenefitsSection data-id="element-163" />
      <PriceSection data-id="element-164" />
      <Footer data-id="element-165" />
    </div>;
}